import Status from '../components/RequestView/Status';
import Step7 from '../components/RequestView/Step7';
import RequestDetails from '../components/RequestView/RequestDetails';
import Search from '../components/Search/Search';
import Errors from '../components/DownloadLinks/Errors';
import Document from '../components/DownloadLinks/Document';
import NewRequest from "../components/NewRequest/NewRequest";
import NewRequest2 from '../components/NewRequest/NewRequest2';
import NewRequest3 from '../components/NewRequest/NewRequest3';
import NewRequest4 from '../components/NewRequest/NewRequest4';
import NewRequest5 from '../components/NewRequest/NewRequest5';
import RequestView from '../components/RequestView/RequestView';
export default[
     { path: "/viewlist", name: "View Request", Component: RequestView, role: "" },
    { path: "/step1", name: "Create New Request", Component: NewRequest, role: "" },
    { path: "/step2", name: "step 2", Component: NewRequest2, role: "" },
    { path: "/step3", name: "step 3", Component: NewRequest3, role: "" },
    { path: "/step4", name: "Request Confirmation", Component: NewRequest4, role: "" },
    { path: "/step5", name: "Request Completed", Component: NewRequest5, role: "" },
    { path: "/requestDetails/:material/:requestorId/:requestDate/:flagFromPage/:quantity", name: "Request Details", Component: RequestDetails, role: "" },
    { path: "/Status/:material/:requestorId/:requestDate/:flagFromPage", name: "Status Approval", Component: Status, role: ["Admin","RequestProcessor"] },
    { path: "/Step7", name: "Status Approval Confirmation", Component: Step7, role: ["Admin","RequestProcessor"] },
    { path: "/search", name: "Search", Component: Search, role: "" },
    { path: "/errors", name: "Error Documents", Component: Errors, role: "" },
    { path: "/document", name: "Documents", Component: Document, role: "" },
    { path: "/JDPoint", name: "JD Point", Component: () => { 
        window.location.href = 'http://parts.deere.com/dns'; 
        return null;
   }, role: "" },
];